<template>
  <div class="slideshow-parent" style="position: relative;">
    <div class="slideshow-container">

      <div class="mySlides fade" :class="{ active: i === index }" :key="slide.id" v-for="(slide, i) in slides">

        <div class="svgContainer desktop-only" :style="`background-image: url('${slide.bgDesktop}'); background-size: cover; height: 100%; width: 100%; object-fit: contain;`">
          <object v-if="slide.fgDesktop" :data="slide.fgDesktop" style="height: 100%; width: 100%; object-fit: contain;"></object>
        </div>

        <div class="svgContainer mobile-only" :style="`background-image: url('${slide.bgMobile}'); background-size: cover; height: 100%; width: 100%; object-fit: contain;`">
          <object v-if="slide.fgMobile" :data="slide.fgMobile" style="height: 100%; width: 100%; object-fit: contain;"></object>
        </div>

        <div v-if="slide.description" class="text" style="background: linear-gradient(3deg, rgba(0,0,0,1) 0%, rgba(0,0,0,0) 100%);">
          <h3>{{slide.title}}</h3>
          {{slide.description}}
          <div v-if="slide.button_url">
            <vs-button class="centrarButton" :href="slide.button_url">{{slide.button_text}}</vs-button>
          </div>
        </div>
      </div>
    </div>

    <a class="arrow prev" @click="showSlides(index - 1)">&#10094;</a>
    <a class="arrow next" @click="showSlides(index + 1)">&#10095;</a>

    <div style="text-align:center">
        <span class="replicate" :key="slide.id" v-for="(slide, i) in slides">
          <span class="dot" :class="{ active: i === index }" @click="showSlides(i)"></span>
        </span>
    </div>
  </div>
</template>

<script>
export default {
  name: "Carousel",
  props: {
    slides: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      index: 0,
      intervalId: null
    }
  },
  methods: {
    showSlides(n) {
      clearInterval(this.intervalId);

      // Lógica limpia para ciclar los slides
      if (n >= this.slides.length) { this.index = 0; }
      else if (n < 0) { this.index = this.slides.length - 1; }
      else { this.index = n; }

      this.startSlideInterval();
    },
    startSlideInterval() {
      this.intervalId = setInterval(() => {
        this.index = (this.index + 1) >= this.slides.length ? 0 : this.index + 1;
      }, 10000);
    },
  },
  created() {
    this.startSlideInterval();
  },
  beforeDestroy() {
    clearInterval(this.intervalId);
  }
}
</script>

<style scoped lang="scss">
// Importamos tu mixin sin la tilde
@import "@elbuenanvita/vuesax/src/styles/mixins";

.slideshow-container {
  width: 85%;
  margin: auto;
  position: relative;
  @include media-breakpoint-down(lg) { // Ajustado para usar el mixin en vez del max-width crudo
    width: 100%;
  }
}

/* Magia Responsiva */
.desktop-only {
  display: block;
  aspect-ratio: 945 / 397;
  @include media-breakpoint-down(sm) {
    display: none;
  }
}

.mobile-only {
  display: none;
  aspect-ratio: 3 / 4;
  @include media-breakpoint-down(sm) {
    display: block;
  }
}

/* Slides */
.mySlides {
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  opacity: 0;
  z-index: 0;
  transition: opacity 0.5s ease; // Transición más fluida

  &.active {
    opacity: 1;
    z-index: 20;
    position: relative; // Para que el contenedor tome la altura del activo
  }
}

.dot {
  cursor: pointer;
  height: 15px;
  width: 15px;
  margin: 0 2px;
  background-color: #bbb;
  border-radius: 50%;
  display: inline-block;
  transition: background-color 0.6s ease;

  &.active, &:hover {
    background-color: #717171;
  }
}

.arrow {
  z-index: 30;
  &.prev, &.next {
    cursor: pointer;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    width: auto;
    margin-top: -22px;
    padding: 16px;
    color: white;
    font-weight: bold;
    font-size: 18px;
    transition: 0.6s ease;
    border-radius: 0 3px 3px 0;
    user-select: none;

    &:hover { background-color: rgba(0,0,0,0.8); }
  }
  &.next {
    right: 0;
    border-radius: 3px 0 0 3px;
  }
}

/* Textos */
.text {
  color: #f2f2f2;
  font-size: 15px;
  position: absolute;
  bottom: 0px;
  width: 100%;
  text-align: center;
}
.text h3 { margin-bottom: 0; }
.centrarButton { margin-left: auto; margin-right: auto; position: relative; }
</style>